<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <div class="searchTitle">
            <b>BLOCKED IP</b>
          </div>

          <el-table
              v-loading="loading"
              ref="multipleTable"
              :data="tableData"
              style="width: 100%; height:100%"
              border
              size="small"
              :row-style="{ height: 0 + 'px' }"
              :cell-style="{ padding: 0 + 'px' }"
              :header-cell-style="{
                background: '#2F384E',
                color: '#fff',
                height: '10px',
                padding: '0px',
              }"
          >
            <el-table-column property="seq" label="seq" width="70"></el-table-column>
            <el-table-column property="ip_address" label="ip_address" width="170"></el-table-column>
            <el-table-column property="auth_code" label="auth_code" width="150"></el-table-column>
            <el-table-column property="reason" label="reason" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column property="reg_date" label="reg_date" width="190"></el-table-column>
            <el-table-column property="expire_date" label="expire_date" width="190"></el-table-column>
            <el-table-column property="use_yn" label="use_yn" width="90"></el-table-column>
          </el-table>

          <div style="text-align:center; margin-top: 10px;">
            <el-pagination
                :current-page.sync="currentPage"
                :page-size="pageSize"
                :total="totalSize"
                layout="prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>

          <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
            <el-button
                :loading="loading"
                type="primary"
                @click="search"
            >Search</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  created() {
    document.onkeydown = this.NotReload;
    this.search();
  },
  data() {
    return {
      tableData: [],
      totalData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
    }
  },
  methods: {
    NotReload() {
      if ((event.ctrlKey == true && (event.keyCode == 78 || event.keyCode == 82)) || (event.keyCode == 116)) {
        event.keyCode = 0;
        event.cancelBubble = true;
        event.returnValue = false;
      }
    },
    async search() {
      this.loading = true;
      let url = this.$url + '/authInfo/getBlockedIpList';

      await Axios.post(url, {}, this.$store.state.config).then(res => {
        var resDataJson = res.data.blockedIpDTO;
        this.totalData = [];
        if (res.data.resultCode) {
          for (var resData in resDataJson) {
            this.totalData.push({
              seq: Number(resData) + 1,
              ip_address: resDataJson[resData]['ip_address'],
              auth_code: resDataJson[resData]['auth_code'],
              reason: resDataJson[resData]['reason'],
              reg_date: resDataJson[resData]['reg_date'],
              expire_date: resDataJson[resData]['expire_date'],
              use_yn: resDataJson[resData]['use_yn'],
            });
          }
          this.totalSize = this.totalData.length;
          this.tableData = this.totalData.slice(0, this.pageSize);
          this.currentPage = 1;
          this.loading = false;
          this.$message.success(this.$store.state.searchSuccess);
        } else {
          this.$message.error(this.$store.state.dataNotFound);
          this.currentPage = 1;
          this.loading = false;
        }
      }).catch(() => {
        this.$message.error(this.$store.state.serverErrorMessage);
        this.currentPage = 1;
        this.loading = false;
      });
    },
    handleCurrentChange(val) {
      this.tableData = this.totalData.slice((this.pageSize * val - this.pageSize), this.pageSize * val);
    },
  }
}
</script>
